import React from 'react';

import { Box } from '@mui/material';

import { VerifierStaffTableWrapperVerifierAdmin } from 'src/components/verifierStaff';
import {
  InviteVerifierStaffByVerifierAdminModal,
  InviteVerifiersAdminsByVerifierAdminModal,
  VerifierStaffViewDetailsByVerifierAdminModal,
} from 'src/modals/verifierStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import type { SxProp } from 'src/types/mui';

export const VerifierStaffPageVerifierAdmin: React.FC = () => {
  return (
    <React.Fragment>
      <Box sx={containerStyles}>
        <TableDataProvider>
          <VerifierStaffTableWrapperVerifierAdmin />
        </TableDataProvider>
      </Box>

      <InviteVerifiersAdminsByVerifierAdminModal />
      <InviteVerifierStaffByVerifierAdminModal />
      <VerifierStaffViewDetailsByVerifierAdminModal />
    </React.Fragment>
  );
};

const containerStyles: SxProp = theme => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasic: '0%',
    flexDirection: 'column',
    height: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    px: 2,
  },
});
